import { DeviceId, StreamIndex, StreamId } from 'types';

export type Output = {
    deviceId: DeviceId;
    streamIndex: StreamIndex;
};

const re = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})_([0123])$/i;
const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const splitStreamId = (streamId: StreamId | null): Output => {
    const match = re.exec(streamId || '');
    if (!match) throw new Error(`${streamId} is not a valid stream ID`);
    return {
        deviceId: match[1],
        streamIndex: parseInt(match[2], 10),
    } as Output;
};

export const isStreamId = (id: any): boolean => // tslint:disable-line:no-any
    typeof id === 'string' && re.test(id)
;

export const makeStreamId = (deviceId: DeviceId, streamIndex: StreamIndex): StreamId => {
    if (typeof deviceId !== 'string' || typeof streamIndex !== 'number' || isNaN(streamIndex)) {
        throw new Error(`Cannot make stream ID from device ${deviceId} and stream ${streamIndex}`);
    }
    if (streamIndex < 0 || streamIndex > 3) {
        throw new Error(`Invalid stream index: ${streamIndex}`);
    }
    if (!guidRegex.test(deviceId)) {
        throw new Error(`Invalid device ID: ${deviceId}`);
    }
    return `${deviceId}_${streamIndex}` as StreamId;
};

export const defaultStreamIdsFromDeviceIds = (deviceIds: ReadonlyArray<DeviceId>): ReadonlyArray<StreamId> =>
    (deviceIds || []).map(deviceId =>
        makeStreamId(deviceId, 0)
    )
;

export const deviceIdsFromStreamIds = (streamIds: ReadonlyArray<StreamId>): ReadonlyArray<DeviceId> => {
    const deviceIds = streamIds.map(streamId => splitStreamId(streamId).deviceId);
    const uniqueDeviceIds = deviceIds.reduce((all, deviceId) => ({ ...all, [deviceId]: deviceId }), {});
    return Object.keys(uniqueDeviceIds);
};



// WEBPACK FOOTER //
// ./src/util/streamId.ts